import { ISystemSettings } from "@/Settings/types/Common/model";
import CommonDivider from "../../../common/CommonDivider";
import CitGraphWidth from "./CitGraphWidth";
import CitMaxGraphValues from "./CitMaxGraphValues";
import CommissionPayout from "./CommissionPayout";
import MaxScheduleDays from "./MaxScheduleDays";
import MinimumBalance from "./MinimumBalance";
import ScheduledAccountNumbers from "./ScheduledAccountNumbers";
import EmailDistribution from "./EmailDistribution";

type TCitProps = {
	action: boolean;
	locationId: string;
	systemSettings?: ISystemSettings | null;
};

const Cit = (props: TCitProps) => {
	const { action, locationId, systemSettings } = props;
	return (
		<>
			<CitGraphWidth citGraphWidth={systemSettings?.citGraphWidth} locationId={locationId} />
			<CommonDivider className="!ml-0" />
			<CitMaxGraphValues action={action} locationId={locationId} citMaxGraphValues={systemSettings?.citMaxGraphValues} />
			<CommonDivider className="!ml-0" />
			<CommissionPayout
				locationId={locationId}
				isPayFundedDealsOnly={!!systemSettings?.citCommissionPayout?.isPayFundedDealsOnly}
				toPositions={systemSettings?.citCommissionPayout?.toPositions}
				mappedPositions={systemSettings?.mappedPositions}
			/>
			<CommonDivider className="!ml-0" />
			<MinimumBalance locationId={locationId} citMinimumBalance={systemSettings?.citMinimumBalance} />
			<CommonDivider className="!ml-0" />
			<MaxScheduleDays locationId={locationId} citMaxScheduleDays={systemSettings?.citMaxScheduleDays} />
			<CommonDivider className="!ml-0" />
			<ScheduledAccountNumbers locationId={locationId} citScheduledAccountNumbers={systemSettings?.citScheduledAccountNumbers} />
			<CommonDivider className="!ml-0" />
			<EmailDistribution
				locationId={locationId}
				citEmailDistribution={systemSettings?.citEmailDistribution}
				citScheduledAccountNumbers={systemSettings?.citScheduledAccountNumbers}
			/>
		</>
	);
};

export default Cit;
